import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { Row, Col, Button, Input, Spin, Modal } from 'antd';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { EditAppProject, DeleteAppProject } from '../gqls'
import Client from '../../../../lib/gqlClient';
const AppProjectPage = (props, ref) => {
    const { TextArea } = Input;
    const navigate = useNavigate();

    const [isGetData, setIsGetData] = useState(false)
    const [ownerDetail, setOwnerDetail] = useState('');
    const [id, setId] = useState('');
    const [projectName, setProjectName] = useState('');
    const [icon, setIcon] = useState('');
    const [defaultProjectDescription, setDefaultProjectDescription] = useState('');
    const [projectDescription, setProjectDescription] = useState('');
    const [projectDetails, setProjectDetails] = useState('none');
    const [owner, setOwner] = useState('');
    const [openModal, setOpenModal] = useState(false);
    React.useEffect(() => {


    }, [])
    useImperativeHandle(ref, () => {
        return {
            setData,
            setDetails,
            setIsOwner
        }
    });
    function setData(data) {
        setId(data._id)
        setProjectName(data.projectName)
        setIcon(data.icon)
        setDefaultProjectDescription(data.description)
        setProjectDescription(data.description)
        setOwnerDetail(data.owner)
    }
    function setDetails(data) {
        setProjectDetails(data)
    }
    function setIsOwner(data) {
        setOwner(data)
    }
    const showInpDescription = e => {
        setProjectDescription(e.target.value);
    }

    function onEditOk(id) {
        editAppProject()

    }
    function onEditNo() {
        setProjectDescription(defaultProjectDescription)
    }
    function editAppProject() {
        setIsGetData(true)
        Client(
            null,
            {
                editAppProjectId: id,
                description: projectDescription
            },
            EditAppProject
        ).then((res) => {
            setIsGetData(false)
            console.log(res)

        }).catch(e => {
            // console.log(e);
            setIsGetData(false)
        })
    }
    function onDeleteProject() {
        setIsGetData(true)
        Client(
            null,
            {
                deleteAppProjectId: id,
            },
            DeleteAppProject
        ).then((res) => {
            setIsGetData(false)
            console.log(res)
            navigate('/developerCenter/apk/appList')
        }).catch(e => {
            // console.log(e);
            setIsGetData(false)
        })
    }
    function onDelete() {
        onDeleteProject()
    }
    return (
        <Spin size="large" tip="Loading..." spinning={isGetData} >
            <div style={{ marginLeft: '30px', marginTop: '30px', display: projectDetails }}>
                <Row>
                    <Col style={{ width: '200px', height: '40px', marginLeft: '20px', fontSize: '18px' }}>应用ID</Col>
                    <Col style={{ height: '40px', marginLeft: '', fontSize: '18px' }}>{id}</Col>
                </Row>
                <Row style={{ marginTop: '20px', }}>
                    <Col style={{ width: '200px', height: '40px', marginLeft: '20px', fontSize: '18px' }}>应用名称</Col>
                    <Col style={{ height: '40px', marginLeft: '', fontSize: '18px' }}>{projectName}</Col>
                </Row>
                <Row style={{ marginTop: '20px', }}>
                    <Col style={{ width: '200px', height: '40px', marginLeft: '20px', fontSize: '18px' }}>应用图标</Col>
                    <Col style={{ marginLeft: '', fontSize: '18px' }}>
                        <img src={icon} style={{ width: '100px', height: '100px',borderRadius: "8px",  }} />
                    </Col>
                </Row>
                <Row style={{ marginTop: '30px', minHeight: '230px' }}>

                    <Col style={{ width: '200px', height: '40px', marginLeft: '20px', fontSize: '18px' }}>应用描述</Col>
                    <Col style={{ width: '400px', height: '200px', resize: 'none', display: owner === 'none' ? '' : 'none' }}>{projectDescription}</Col>
                    <Col style={{ height: '40px', marginLeft: '', fontSize: '18px', display: owner }}>

                        <TextArea
                            value={projectDescription}
                            onChange={showInpDescription}
                            style={{ width: '400px', height: '200px', resize: 'none', }} />
                        <Row style={{ marginTop: '10px', marginBottom: '20px' }}>
                            <Col >
                                <Button onClick={() => onEditOk()} style={{ height: '30px', resize: 'none', borderRadius: "15px", }}>
                                    保存
                                </Button>
                            </Col>
                            <Col >
                                <Button onClick={() => onEditNo()} style={{ marginLeft: '10px', height: '30px', resize: 'none', borderRadius: "15px", }}>
                                    取消
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row style={{ marginTop: '30px', display: 'flex', alignItems: 'center', }}>
                    <div style={{ width: '200px', height: '40px', marginLeft: '20px', fontSize: '18px' }}>owner</div>
                    <div style={{  height: '40px',fontSize: '18px', }}>{ownerDetail}</div>
                </Row>
                <Row style={{ marginTop: '30px',  display: owner }}>
                    <Col style={{ width: '200px', height: '40px', marginLeft: '20px', marginTop: '10px', fontSize: '18px' }}>删除项目</Col>
                    <Col style={{ height: '40px', marginLeft: '', }}>
                        <Button onClick={() => setOpenModal(true)} style={{ height: '40px', width: '120px', fontSize: '16px', resize: 'none', borderRadius: "20px", borderColor: '#FF5300', color: '#FF5300' }}>删除</Button>
                    </Col>
                </Row>
                <Modal
                    closable={false}
                    centered
                    open={openModal}
                    footer={null}
                    width={320}
                    destroyOnClose={true}
                    maskStyle={{ animation: 'none', background: 'ffffff', opacity: '0.5', padding: '0px' }}
                    bodyStyle={{ padding: '0px', width: '320px', background: 'ffffff', borderRadius: '10px' }}
                    style={{ borderRadius: "10px", overflow: "auto" }}
                >
                    <div style={{ fontSize: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '112px' }}>
                        <div >删除项目</div>
                    </div>

                    <div style={{ height: '1px', width: '320px', background: 'rgba(0, 0, 0, 0.1)' }}></div>
                    <Row>
                        <Col span={'159.5px'}>
                            <Button type="text" onClick={() => onDelete()} style={{ color:'#FF5300', fontSize: '16px', width: '159.5px', height: '56px' }}>Delete</Button>
                        </Col>
                        <Col span={'1px'}>
                            <div style={{ height: '56px', width: '1px', background: 'rgba(0, 0, 0, 0.1)' }}></div>
                        </Col>
                        <Col span={'159.5px'}>
                            <Button type="text" onClick={() => setOpenModal(false)} style={{ fontSize: '16px', width: '159.5px', height: '56px' }}>Cancel</Button>
                        </Col>
                    </Row>

                </Modal>
            </div>
        </Spin>

    )

}

export default forwardRef(AppProjectPage)